import styled from "styled-components";

export const FirstRowContainer = styled.div`
    display: flex;
    justify-content: space-between;
`
